// SWIPER CAROUSEL INIT - multiple instances support
document.addEventListener('DOMContentLoaded', function() {
    // Select all wrapper containers
    const carousels = document.querySelectorAll('.db-widget.carousel');

    carousels.forEach(function(carousel) {
        const id = carousel.getAttribute('id'); // pak unieke id van jouw PHP render

        // Check of er een swiper in zit
        const swiperEl = carousel.querySelector('.swiper');
        if (!swiperEl) return;

        // Init a new Swiper instance for this container
        new Swiper(`#${id} .swiper`, {
            loop: false,
            speed: 350,
            allowTouchMove: true,
            slidesPerView: 1.15,
            freeMode: false,
            slidesPerGroup: 1,
            spaceBetween: 20,
            centeredSlides: false,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            navigation: {
                nextEl: `#${id} .swiper-button-next`,
                prevEl: `#${id} .swiper-button-prev`
            },
            scrollbar: {
                el: `#${id} .swiper-scrollbar`,
                draggable: true,
                snapOnRelease: false,
            },
            observer: true,
            observeParents: true,
            resizeObserver: true,
            breakpoints: {
                768: { slidesPerView: 2.3, spaceBetween: 30 },
                992: { slidesPerView: 2.66 }
            }
        });
    });
});